import { create } from 'zustand';
import type { NotificationMessage } from '../realtime/notificationMessage';

/** Cap matches WPF practical memory limits for an in-session event log. */
const MAX_EVENTS = 2000;

export interface SignalRLogEntry extends NotificationMessage {
  /** Local receive order for stable AG Grid row ids. */
  receivedAt: string;
  sequence: number;
}

interface SignalREventLogState {
  events: SignalRLogEntry[];
  nextSequence: number;
  append: (message: NotificationMessage) => void;
  clear: () => void;
}

export const useSignalREventLog = create<SignalREventLogState>((set) => ({
  events: [],
  nextSequence: 1,
  append: (message) =>
    set((state) => {
      const entry: SignalRLogEntry = {
        ...message,
        receivedAt: new Date().toISOString(),
        sequence: state.nextSequence,
      };
      const events = [...state.events, entry];
      if (events.length > MAX_EVENTS) {
        events.splice(0, events.length - MAX_EVENTS);
      }
      return { events, nextSequence: state.nextSequence + 1 };
    }),
  clear: () => set({ events: [], nextSequence: 1 }),
}));
